export const containsHtmlTags = (value: string): boolean => {
  return /<[^>]*>/.test(value);
};

export const containsURL = (value: string): boolean => {
  return /(?:https?:\/\/|ftp:\/\/|www\.)\S+|\b[a-zA-Z0-9]{2,}\.[a-zA-Z]{2,}\b/i.test(value);
};
